import { FC, ReactNode } from 'react';
import Icon from '@ant-design/icons';
import { Col, ModalProps, Row } from 'antd';
import CloseSvg from 'global/Icons/CloseSvg';
import { CloseButton, HeaderRow, Modal, Title } from './styled';

// TODO: Adjust onCancel to be have optional type param
export interface BaseModalProps extends Omit<ModalProps, 'onCancel'> {
  prefix?: ReactNode;
  hideHeader?: boolean;
  onCancel?: (e?: React.MouseEvent<HTMLElement>) => void;
}

const BaseModal: FC<BaseModalProps> = ({
  prefix,
  title,
  children,
  closable = true,
  hideHeader = false,
  ...props
}) => (
  <Modal centered footer={null} {...props} closable={false}>
    {!hideHeader && (
      <HeaderRow
        className="base-modal-header"
        align="middle"
        justify="space-between"
      >
        <Col span={1}>{prefix}</Col>

        <Col span={22}>
          <Row align="middle" justify="center">
            <Col>
              <Title className="base-modal-title">{title}</Title>
            </Col>
          </Row>
        </Col>

        <Col span={1}>
          {closable && (
            <CloseButton onClick={props.onCancel}>
              <Icon
                style={{ fontSize: 10, color: '#969696' }}
                component={CloseSvg}
              />
            </CloseButton>
          )}
        </Col>
      </HeaderRow>
    )}

    {children}
  </Modal>
);

export default BaseModal;
